import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { EligibleVppProgramDto } from "../dto/proposal-vpp-incentive.dto"
import { proposalVppIncentiveService } from "../services/proposal-vpp-incentive.service"

export default function useFetchEligibleVppPrograms(
  proposalId: string | undefined,
): UseQueryResult<EligibleVppProgramDto[], unknown> {
  return useQuery({
    queryKey: queryKeys.proposalVppIncentives.eligible(proposalId),
    queryFn: () =>
      proposalVppIncentiveService.fetchEligiblePrograms(proposalId!),
    enabled: !!proposalId,
  })
}
